import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { faCheckCircle, faTimesCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PropTypes } from '@panneau/core';
import Label from '@panneau/element-label';
import classNames from 'classnames';
import PropTypes$1 from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

var propTypes = {
  status: PropTypes.formStatus,
  successLabel: PropTypes.label,
  errorLabel: PropTypes.label,
  loadingLabel: PropTypes.label,
  className: PropTypes$1.string
};
var defaultProps = {
  status: null,
  successLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "ESkxLX",
    defaultMessage: [{
      "type": 0,
      "value": "Success!"
    }]
  }),
  errorLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Mo0yQb",
    defaultMessage: [{
      "type": 0,
      "value": "Error"
    }]
  }),
  loadingLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "5rMPIj",
    defaultMessage: [{
      "type": 0,
      "value": "Loading..."
    }]
  }),
  className: null
};
var FormStatus = function FormStatus(_ref) {
  var status = _ref.status,
    successLabel = _ref.successLabel,
    errorLabel = _ref.errorLabel,
    loadingLabel = _ref.loadingLabel,
    className = _ref.className;
  var label = null;
  if (status === 'success') {
    label = successLabel;
  } else if (status === 'error') {
    label = errorLabel;
  } else if (status === 'loading') {
    label = loadingLabel;
  }
  var icon = null;
  if (status === 'success') {
    icon = faCheckCircle;
  } else if (status === 'error') {
    icon = faTimesCircle;
  } else if (status === 'loading') {
    icon = faSpinner;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['d-flex', 'align-items-center', _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "text-danger", status === 'error'), "text-success", status === 'success'), "text-muted", status === 'loading'), className, className !== null)])
  }, icon !== null ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: icon,
    className: classNames(['me-2', {
      'fa-spin': status === 'loading'
    }])
  }) : null, /*#__PURE__*/React.createElement(Label, null, label));
};
FormStatus.propTypes = propTypes;
FormStatus.defaultProps = defaultProps;

export { FormStatus as default };
